import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Row, Col } from 'react-flexbox-grid';
import { Checkbox, DatePicker, Form, Input, InputNumber, Select, Button, Spin, message } from 'antd';
import moment from 'moment';

import { DeclarationOfCorrectInformationLabel, PunctuationAlert } from '../../common/partials';
import rules from '../../../../common/rules/rules';
import { educationT, socialStatus, socialStatusT, onboardingSteps } from '../../../../common/enums';
import { translation as sectorTranslation } from '../../../../common/enums/sector';
import { translation as obligationTypeTranslation } from '../../../../common/enums/obligationType';
import Cookies from 'js-cookie';
import { PasswordInput } from '../../../../common/components';
import accountRules from '../../../../common/rules/accountRules';

const FormItem = Form.Item;
const noMonthlyPaymentObligationTypes = ['KREDITNA_KARTA', 'KONTOKORENT'];

@Form.create()
@translate()
export default class StepForm3 extends Component {
  static propTypes = {
    accountData: PropTypes.object.isRequired,
    form: PropTypes.object.isRequired,
    saveAndGoToStep: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    t: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props)

    const showEmployerStatuses = [
      socialStatus.EMPLOYED_INDEFINITE,
      socialStatus.EMPLOYED_DEFINITE,
      socialStatus.AGREEMENT_OTHER,
    ];
    const noSectorStatuses = [
      socialStatus.UNEMPLOYED,
      socialStatus.STUDENT,
      socialStatus.RETIRED,
      socialStatus.MATERNAL_LEAVE,
    ];
    let showEmployer = false
    if (props.accountData && (
      showEmployerStatuses.includes(props.accountData.socialStatus) ||
      [socialStatus.SELF_EMPLOYED, socialStatus.OWN_BUSINESS_INCOME].includes(props.accountData.socialStatus)
    )) {
      showEmployer = true
    }
    const initialSocialStatus = props.accountData ? props.accountData.socialStatus : null;

    this.state = {
      repeatPasswordDirty: false,
      showEmployer: showEmployer,
      showCompanyName: initialSocialStatus ? [socialStatus.SELF_EMPLOYED, socialStatus.OWN_BUSINESS_INCOME].includes(initialSocialStatus) : false,
      showSector: initialSocialStatus ? !noSectorStatuses.includes(initialSocialStatus) : false,
      obligations: (props.accountData && props.accountData.obligations) ? props.accountData.obligations : [],
    };
  }

  handleSubmit = e => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    const { form, t } = this.props;

    form.validateFields((err, formData) => {
      if (err) {
        return;
      }

      const invalidObligations = this.state.obligations.filter(o => {
        if (!o.type) return false;
        if (!o.originalAmount || o.originalAmount <= 0) return true;
        if (!o.provider || o.provider.trim() === '') return true;
        if (!noMonthlyPaymentObligationTypes.includes(o.type)) {
          if (!o.monthlyPayment || o.monthlyPayment <= 0) return true;
        }
        return false;
      });

      if (invalidObligations.length > 0) {
        setTimeout(() => message.error(t('Vyplňte všetky povinné polia záväzkov')), 0);
        return;
      }

      const validObligations = this.state.obligations
        .filter(o => o.type)
        .map(o => {
          const cleaned = { ...o };
          if (noMonthlyPaymentObligationTypes.includes(cleaned.type)) {
            delete cleaned.monthlyPayment;
          }
          return cleaned;
        });

      formData.cookieId = Cookies.get('id');
      formData.obligations = validObligations;

      this.props.saveAndGoToStep(onboardingSteps[3], formData);
    });
  };


  handleRepeatPasswordBlur = e => {
    const { repeatPasswordDirty } = this.state;

    this.setState({ repeatPasswordDirty: repeatPasswordDirty || !!e.target.value });
  };

  handleSocialStatusChange = value => {
    const noSectorStatuses = [socialStatus.UNEMPLOYED, socialStatus.STUDENT, socialStatus.RETIRED, socialStatus.MATERNAL_LEAVE];
    this.setState({
      showEmployer: [
        socialStatus.EMPLOYED_INDEFINITE,
        socialStatus.EMPLOYED_DEFINITE,
        socialStatus.AGREEMENT_OTHER,
        socialStatus.SELF_EMPLOYED,
        socialStatus.OWN_BUSINESS_INCOME,
      ].includes(value),
      showCompanyName: [socialStatus.SELF_EMPLOYED, socialStatus.OWN_BUSINESS_INCOME].includes(value),
      showSector: !noSectorStatuses.includes(value),
    });
    if (noSectorStatuses.includes(value)) {
      this.props.form.setFieldsValue({ sector: undefined });
    }
  };

  addObligation = () => {
    this.setState(prev => ({
      obligations: [...prev.obligations, { type: null, originalAmount: null, monthlyPayment: null, provider: '' }],
    }));
  };

  removeObligation = (index) => {
    this.setState(prev => ({
      obligations: prev.obligations.filter((_, i) => i !== index),
    }));
  };

  updateObligation = (index, field, value) => {
    this.setState(prev => {
      const obligations = [...prev.obligations];
      obligations[index] = { ...obligations[index], [field]: value };
      if (field === 'type' && noMonthlyPaymentObligationTypes.includes(value)) {
        obligations[index].monthlyPayment = null;
      }
      return { obligations };
    });
  };

  onBlurSaveLoanData = e => {
    this.handleSaveLoanCreationAttempt();
  }

  async handleSaveLoanCreationAttempt() {
    this.props.updateLoanCreationAttempt({ cookieId: Cookies.get('id'), form: this.props.form, step: 3, params: { obligations: this.state.obligations } });
  }
  goBack = () => this.props.saveAndGoToStep(onboardingSteps[1], { ...this.props.form.getFieldsValue(), obligations: this.state.obligations });

  render() {
    const { accountData, form, isLoading, t } = this.props;
    const { getFieldDecorator } = form;
    const { showEmployer } = this.state;
    const { repeatPasswordDirty } = this.state;

    if (!accountData || !accountData.income || !accountData.costs) {
      return <Spin spinning={true} />;
    }
    
    return (
      <section className="onboarding-form">
        <h2 className="section-title">{t('Vzdelanie a financie')}</h2>
        <PunctuationAlert />
        <Spin spinning={isLoading}>
          <Form layout="vertical">
            <Row>
              <Col xs>
                <FormItem label={t('Dokončené vzdelanie')}>
                  {getFieldDecorator('education', {
                    initialValue: accountData.education,
                  })(
                    <Select size="default" placeholder={t('Dokončené vzdelanie')} onBlur={this.onBlurSaveLoanData}>
                      {Object.entries(educationT).map(([key, value]) => (
                        <Select.Option value={key} key={key}>
                          {value}
                        </Select.Option>
                      ))}
                    </Select>
                  )}
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col xs>
                <FormItem label={t('Zdroj príjmu')}>
                  {getFieldDecorator('socialStatus', {
                    rules: rules.required,
                    initialValue: accountData.socialStatus,
                  })(
                    <Select
                      size="default"
                      placeholder={t('Zdroj príjmu')}
                      onChange={this.handleSocialStatusChange}
                      onBlur={this.onBlurSaveLoanData}
                    >
                      {Object.entries(socialStatusT).map(([key, value]) => (
                        <Select.Option value={key} key={key}>
                          {value}
                        </Select.Option>
                      ))}
                    </Select>
                  )}
                </FormItem>
              </Col>
            </Row>
            {showEmployer && (
              <Row>
                <Col xs>
                  <FormItem label={t(this.state.showCompanyName ? 'Názov spoločnosti' : 'Názov zamestnávateľa')}>
                    {getFieldDecorator('employer', {
                      initialValue: accountData.employer,
                      rules: [{ required: true, message: t('Povinné pole') }],
                    })(<Input size="default" placeholder={t(this.state.showCompanyName ? 'Názov spoločnosti' : 'Názov zamestnávateľa')} onBlur={this.onBlurSaveLoanData} />)}
                  </FormItem>
                </Col>
              </Row>
            )}
            <Row>
              <Col xs={12} sm={6}>
                <FormItem label={t('Príjem od')}>
                  {getFieldDecorator('incomeFrom', {
                    initialValue: accountData.incomeFrom ? moment(accountData.incomeFrom) : null,
                    rules: [{ required: true, message: t('Povinné pole') }],
                  })(
                    <DatePicker
                      size="default"
                      style={{ width: '100%' }}
                      format="DD.MM.YYYY"
                      onBlur={this.onBlurSaveLoanData}
                    />
                  )}
                </FormItem>
              </Col>
              {this.state.showSector && (
                <Col xs={12} sm={6}>
                  <FormItem label={t('Odvetvie')}>
                    {getFieldDecorator('sector', {
                      initialValue: accountData.sector,
                      rules: [{ required: true, message: t('Povinné pole') }],
                    })(
                      <Select size="default" onBlur={this.onBlurSaveLoanData}>
                        {Object.entries(sectorTranslation).map(([key, label]) => (
                          <Select.Option key={key} value={Number(key)}>{label}</Select.Option>
                        ))}
                      </Select>
                    )}
                  </FormItem>
                </Col>
              )}
            </Row>
            <Row>
              <Col xs={12} sm={6}>
                <FormItem label={t('Priemerný mesačný príjem v čistom v EUR')}>
                  {getFieldDecorator('income.monthlyAvg', {
                    rules: rules.required,
                    initialValue: accountData.income.monthlyAvg,
                  })(
                    <InputNumber
                      size="default"
                      placeholder={t('Priemerný mesačný príjem v čistom v EUR')}
                      min={0}
                      onBlur={this.onBlurSaveLoanData}
                    />
                  )}
                </FormItem>
              </Col>
              <Col xs={12} sm={6}>
                <FormItem label={t('Približné mesačné náklady v EUR')}>
                  {getFieldDecorator('costs.monthlyAvg', {
                    rules: rules.required,
                    initialValue: accountData.costs.monthlyAvg,
                  })(
                    <InputNumber
                      size="default"
                      placeholder={t('Približné mesačné náklady v EUR')}
                      min={0}
                      onBlur={this.onBlurSaveLoanData}
                    />
                  )}
                </FormItem>
              </Col>
            </Row>
            <div className="section-title">{t('Záväzky')}</div>
            <p style={{ fontSize: '16px', marginBottom: '16px' }}>
              {t('Doplňte údaje o Vašich úveroch, kreditných kartách, prípadne iných záväzkoch.')}
            </p>

            {this.state.obligations.map((obligation, index) => (
              <Row key={index} style={{ marginBottom: '8px', alignItems: 'flex-start' }}>
                <Col xs={12} sm={3}>
                  <FormItem label={index === 0 ? t('Typ záväzku') : ''}>
                    <Select
                      value={obligation.type}
                      onChange={(val) => this.updateObligation(index, 'type', val)}
                      placeholder={t('Vyberte typ')}
                    >
                      {Object.entries(obligationTypeTranslation).map(([key, label]) => (
                        <Select.Option key={key} value={key}>{label}</Select.Option>
                      ))}
                    </Select>
                  </FormItem>
                </Col>
                <Col xs={12} sm={3}>
                  <FormItem label={index === 0 ? t('Pôvodná výška v EUR') : ''}>
                    <InputNumber
                      min={0}
                      precision={0}
                      style={{ width: '100%' }}
                      value={obligation.originalAmount}
                      onChange={(val) => this.updateObligation(index, 'originalAmount', val)}
                    />
                  </FormItem>
                </Col>
                <Col xs={12} sm={3}>
                  <FormItem label={index === 0 ? t('Mesačná splátka v EUR') : ''}>
                    <InputNumber
                      min={0}
                      precision={0}
                      style={{ width: '100%' }}
                      value={noMonthlyPaymentObligationTypes.includes(obligation.type) ? undefined : obligation.monthlyPayment}
                      onChange={(val) => this.updateObligation(index, 'monthlyPayment', val)}
                      disabled={noMonthlyPaymentObligationTypes.includes(obligation.type)}
                    />
                  </FormItem>
                </Col>
                <Col xs={12} sm={2}>
                  <FormItem label={index === 0 ? t('Kto poskytol') : ''}>
                    <Input
                      maxLength={20}
                      value={obligation.provider}
                      onChange={(e) => this.updateObligation(index, 'provider', e.target.value)}
                    />
                  </FormItem>
                </Col>
                <Col xs={12} sm={1} style={index === 0 ? { paddingTop: '29px' } : {}}>
                  <Button type="link" icon="close" onClick={() => this.removeObligation(index)} />
                </Col>
              </Row>
            ))}

            <Button type="dashed" onClick={this.addObligation} style={{ width: '100%', marginBottom: '16px' }}>
              + {t('Pridať záväzok')}
            </Button>

            <Row>
              <Col xs={12} sm={6}>
                <FormItem label={t('Dlh na poistnom alebo daniach v EUR')}>
                  {getFieldDecorator('insuranceTaxDebt', {
                    initialValue: accountData.insuranceTaxDebt,
                    rules: [],
                  })(
                    <InputNumber
                      min={0}
                      precision={0}
                      style={{ width: '100%' }}
                      onBlur={() => this.onBlurSaveLoanData()}
                    />
                  )}
                </FormItem>
              </Col>
            </Row>

            <Row>
              <Col xs={12} sm={6}>
                <FormItem label={t('Heslo')}>
                  {getFieldDecorator('password', {
                    rules: [
                      ...accountRules.passwordWithLimit,
                      {
                        validator: accountRules.checkRepeatPassword(form, repeatPasswordDirty),
                      },
                    ],
                    initialValue: accountData.password,
                  })(
                    <PasswordInput
                      placeholder={t('Vytvorte si heslo pre vstup do klientskej zóny')}
                    />
                  )}
                </FormItem>
              </Col>
              <Col xs={12} sm={6}>
                <FormItem label={t('Overenie hesla')}>
                  {getFieldDecorator('repeatPassword', {
                    rules: [
                      ...accountRules.passwordWithLimit,
                      {
                        validator: accountRules.checkPassword(form),
                      },
                    ],
                    initialValue: accountData.repeatPassword,
                    validateTrigger: 'onBlur',
                  })(
                    <Input
                      size="default"
                      type="password"
                      placeholder={t('Overenie hesla pre vstup do klientskej zóny')}
                      onBlur={this.handleRepeatPasswordBlur}
                    />
                  )}
                </FormItem>
              </Col>
            </Row>

            <Row>
              <Col xs>
                <FormItem>
                  {getFieldDecorator('declarationOfCorrectInformation', {
                    rules: rules.radioAgreement,
                    initialValue: accountData.declarationOfCorrectInformation,
                  })(
                    <div className="terms-wrapper">
                      <Checkbox defaultChecked={true} onBlur={this.onBlurSaveLoanData} />
                      <DeclarationOfCorrectInformationLabel />
                    </div>
                  )}
                </FormItem>
              </Col>
            </Row>
            <Row center="xs" className="form-actions-row">
              <Col xs={12} sm={6} className="form-actions-col">
                <a onClick={this.goBack}>{t('Späť')}</a>
                <Button type="primary" size="large" htmlType="submit" className="btn-block" onClick={(e) => this.handleSubmit(e)}>
                  {t('Ďalej')}
                </Button>
              </Col>
            </Row>
          </Form>
        </Spin>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/onboarding/components/debtor/StepForm3.js